import { Col, FormGroup, FormLabel, Row } from "react-bootstrap";
import ZipCodeInput from "../../../Common/ZipCodeInput";
import InputText from "../../../Forms/Element/InputText";
import { useTranslation } from "react-i18next";
import { searchAddressByZipCode } from "./AddressUtils";
import { useState } from "react";
import "./AddressRegistration.css";
import { Spinner } from "react-bootstrap";
import { errorAlert } from "../../../alert/defaultAlert";

const AddressRegistration = (props) => {

    const { t } = useTranslation();
    const { formik } = props;
    const [showLoading, setShowLoading] = useState(false);
    const [searchedZipCode, setSearchedZipCode] = useState(null);

    /**
     * Obtém o endereço através do cep.
     */
    function searchAddress(zipCode) {
        if(zipCode !== searchedZipCode && zipCode.trim() !== '') {
            setShowLoading(true);

            searchAddressByZipCode(zipCode)
            .then((resp) => {
                // Guarda o cep encontrado para que o usuário não fique fazendo pesquisa
                // quando for o mesmo CEP. A api só deve ser acionada se for um CEP diferente 
                // do armazenado na variável.
                setSearchedZipCode(resp.zipCode);
                
                // Preenche o formulário
                formik.setFieldValue('street', resp.street);
                formik.setFieldValue('neighborhood', resp.neighborhood);
                formik.setFieldValue('city', resp.city);
                formik.setFieldValue('state', resp.state);
            }).catch((error) => {
                 // Retorna para o estado padrão para que seja realizada
                // uma nova consulta de cep.
                setSearchedZipCode(null);

                errorAlert(t(error.message));
            })
            .finally(() => {
                setShowLoading(false);
            });
        }   
    }

    return (
        <>
            <Row className="mb-3">
                <Col md={2} className="mb-2">
                    <FormGroup>
                        <FormLabel>{t('address.zipCode')}</FormLabel>
                        {/* O spinner fica dentro do campo, onde a pessoa está olhando. O ícone antigo de
                            carregamento é da versão paga do FontAwesome e nem sempre aparecia. */}
                        <div className="address-zip">
                            <ZipCodeInput
                                name="zipCode"
                                onChange={formik.handleChange}
                                onBlur={() => searchAddress(formik.values.zipCode)}
                                value={formik.values.zipCode}
                                error={formik.errors.zipCode}
                            />
                            {showLoading && <Spinner animation="border" size="sm" className="address-zip__spinner" role="status" aria-label={t('message.looking')} />}
                        </div>
                        {showLoading && <small className="address-looking" role="status">{t('message.looking')}</small>}
                    </FormGroup>
                </Col>
                <Col md={4} className="mb-2">
                    <FormGroup>
                        <FormLabel>{t('address.street')}</FormLabel>
                        <InputText
                            name="street"
                            disabled={showLoading}
                            placeholder={showLoading ? t('message.looking') : undefined}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.street}
                            error={formik.errors.street}
                            maxlenght="50"
                        />
                    </FormGroup>
                </Col>
                <Col md={2} className="mb-2">
                    <FormGroup>
                        <FormLabel>{t('address.number')}</FormLabel>
                        <InputText
                            name="number"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.number}
                            error={formik.errors.number}
                            maxlenght="10"
                        />
                    </FormGroup>
                </Col>
                <Col md={4} className="mb-2">
                    <FormGroup>
                        <FormLabel>{t('address.complement')}</FormLabel>
                        <InputText
                            name="complement"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.complement}
                            error={formik.errors.complement}
                            maxlenght="30"
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col md={4} className="mb-2">
                    <FormGroup>
                        <FormLabel>{t('address.neighborhood')}</FormLabel>
                        <InputText
                            name="neighborhood"
                            disabled={showLoading}
                            placeholder={showLoading ? t('message.looking') : undefined}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.neighborhood}
                            error={formik.errors.neighborhood}
                        />
                    </FormGroup>
                </Col>
                <Col md={4} className="mb-2">
                    <FormGroup>
                        <FormLabel>{t('address.city')}</FormLabel>
                        <InputText
                            name="city"
                            disabled={showLoading}
                            placeholder={showLoading ? t('message.looking') : undefined}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.city}
                            error={formik.errors.city}
                        />
                    </FormGroup>
                </Col>
                <Col md={2} className="mb-2">
                    <FormGroup>
                        <FormLabel>{t('address.state')}</FormLabel>
                        <InputText
                            name="state"
                            disabled={showLoading}
                            placeholder={showLoading ? t('message.looking') : undefined}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.state}
                            error={formik.errors.state}
                        />
                    </FormGroup>
                </Col>
            </Row>
        </>
    )
}

export default AddressRegistration;